import React, { useState, useContext } from "react";
// @mui material components
import Card from "@mui/material/Card";
import { CardHeader } from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Switch from "@mui/material/Switch";
import { LanguageContext } from "App";
import SearchStringOrIntReq2 from "Classes/Models/Requests/SearchStringOrIntReq";
import AccountingApi from "Classes/API/AccountingApi";

const ContractDetailsCard = ({
  Contract,
  setShowSessions,
  ShowSessions,
  setShowAddPatients,
  ShowAddPatients,
}) => {
  const { translations } = useContext(LanguageContext);

  const getContractReport = async (id) => {
    let SearchStringOrIntReq = new SearchStringOrIntReq2();

    SearchStringOrIntReq.SearchInt = id;
    var res = await AccountingApi.GetContractReport(SearchStringOrIntReq);
    AccountingApi.downloadContractReportCSV(res);
  };

  return (
    <Card
      sx={{ height: "100%", boxShadow: !false && "none", marginBottom: "2em", padding: "10px" }}
    >
      <CardHeader title={translations.ContractInfo} />
      <div className="row">
        <div className="col-md-3  ">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.ContractInfoName}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Contract.name}
          </MDTypography>
        </div>
        <div className="col-md-3">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.ContractInfoDescription}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Contract.description}
          </MDTypography>
        </div>

        <div className="col-md-3">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.ContractInfoCreatedAt}: &nbsp;
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{Contract.timeStamp.split("T")[0]}
          </MDTypography>
        </div>
        <div className="col-md-3">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.ContractInfoShowSessions}: &nbsp;
          </MDTypography>
          <MDBox>
            <Switch checked={ShowSessions} onChange={() => setShowSessions(!ShowSessions)} />
          </MDBox>
        </div>
        <div className="col-md-3 mt-4 ">
          <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
            {translations.ContractInfoShowPatients}: &nbsp;
          </MDTypography>
          <MDBox>
            <Switch
              checked={ShowAddPatients}
              onChange={() => setShowAddPatients(!ShowAddPatients)}
            />
          </MDBox>
        </div>
        <div className="col-md-3 mt-4">
          <button
            className="btn btn-outline-primary"
            onClick={() => getContractReport(Contract.id)}
          >
            Download report
          </button>
        </div>
      </div>
    </Card>
  );
};

export default ContractDetailsCard;
